import {
  beforeAuthStateChanged,
  onIdTokenChanged,
  type Auth,
  type User,
} from "firebase/auth";

export default defineNuxtPlugin((nuxtApp) => {
  const auth = nuxtApp.$firebaseAuth as Auth | null | undefined;

  if (!auth) {
    return;
  }

  const firebaseAuth = auth;

  async function syncSessionCookie(user: User | null | undefined) {
    try {
      const token = await user?.getIdToken();

      await $fetch("/api/__session", {
        method: "POST",
        body: { token },
      });
    } catch (error) {
      console.warn("[firebase-session-cookie] Unable to sync session", error);
    }
  }

  beforeAuthStateChanged(firebaseAuth, syncSessionCookie);
  onIdTokenChanged(firebaseAuth, syncSessionCookie);
});
